import { Mail, Ban } from 'lucide-react'

export const receiptOptions = [
  {
    key: 'email' as const,
    icon: Mail,
    colorClass: 'bg-blue-50 text-blue-600',
    title: 'Email Receipt',
    description: 'Send receipt to your email address.',
  },
  {
    key: 'none' as const,
    icon: Ban,
    colorClass: 'bg-secondary-100 text-secondary-600',
    title: 'No Receipt',
    description: 'Skip receipt and continue',
  },
]
